import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

function getFormattedDateRange(startTimestampMs, endTimestampMs, format = 'DD MMM YYYY') {
  if (!startTimestampMs || !endTimestampMs) {
    throw new Error('All dates should be provided');
  }

  const startTimestamp = dayjs(startTimestampMs).utc();
  const endTimestamp = dayjs(endTimestampMs).utc();

  const formattedStartDate = startTimestamp.format(format);
  const formattedEndDate = endTimestamp.format(format);

  if (endTimestamp.diff(startTimestamp, 'day') < 1) {
    return formattedStartDate;
  }

  return `${formattedStartDate} - ${formattedEndDate}`;
}

export default getFormattedDateRange;
